import { Action } from 'redux';

import { ISetFavoriteEntityType } from './favorite_entity_type';
import { FILTERS_SET_DEAL_TYPE_TYPE, FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE } from '../../constants/actionTypes';
import { EEntityType, EDealType } from '../../types/filters';
import { TThunkAction } from '../../types/redux';

export type TSetDealTypeType = 'filters/set_deal_type';

export interface ISetDealType extends Action<TSetDealTypeType> {
  type: TSetDealTypeType;
  dealType: EDealType | null;
}

export function setDealType(dealType: EDealType | null): TThunkAction {
  return (dispatch, getState) => {
    const {
      filters: { favoriteEntityType },
    } = getState();

    dispatch<ISetDealType>({
      dealType,
      type: FILTERS_SET_DEAL_TYPE_TYPE,
    });

    if (favoriteEntityType === EEntityType.Newbuilding && !!dealType && dealType !== EDealType.Sale) {
      dispatch<ISetFavoriteEntityType>({
        favoriteEntityType: null,
        type: FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE,
      });
    }
  };
}
